export const doesSchemaHaveType = (schema, type) => {
    return schema.type === type || schema.type?.includes(type) || false;
};
//# sourceMappingURL=schema.utils.js.map